<script lang='ts'>
  import type { SellSheet } from '@shared/types/SellSheet';
  import type { SellSheetRetailerUser } from '@shared/types/User';
  import Icon from '@shared/svelte/Components/Icon.svelte';
  import ShareSelectRetailers from './ShareSelectRetailers.svelte';
  import CustomModal from './CustomModal.svelte';
  import * as _ from 'lodash';

  export let showShareSellSheetModal: boolean;
  export let sellSheet: SellSheet;
  export let retailerUserCount: number;
  export let closeModal: () => void;
  export let shareWithAll: () => void;
  export let shareWithSelected: (retailerIds: number[]) => void;
  export let searchRetailers: (distributorId: number, searchTerm: string) => Promise<SellSheetRetailerUser[]>;
  export let retailersLoaded: boolean;
  export let showLoading: boolean;

  const manufacturer = _.get(window, '$rootScope.user.manufacturers[0]')
  let shareType: string = 'all';
  let shareOptions = [];
  if (manufacturer) {
    shareOptions = [
      {
        name: 'share-select',
        value: 'select',
        label: 'Select individual retailers'
      }
    ];
    shareType = 'select';
  } else {
    shareOptions = [
      {
        name: 'share-all',
        value: 'all',
        label: `With all retailers (${retailerUserCount})`
      },
      {
        name: 'share-select',
        value: 'select',
        label: 'Select individual retailers'
      }
    ];
  }

  let sharingWithRetailers = [];
  $: disableButton = shareType === 'select' && sharingWithRetailers.length === 0;

  // closes the modal when on background click
  $: if(!showShareSellSheetModal) {
    cancelAction();
  }

  function cancelAction() {
    sharingWithRetailers = [];
    closeModal()
  }

  function shareWith() {
    if(shareType === 'all') {
      shareWithAll();
    }
    else {
      shareWithSelected(sharingWithRetailers);
    }
  }

  let innerWidth: number = null;
  $: responsiveLayout = innerWidth && innerWidth < 700;
</script>

<style lang='scss'>
  .sticky-footer {
    @media (min-width: 700px) {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }

  .share-method {
    @media (max-width: 700px) {
      overflow-y: auto;
      height: 30rem;
    }
  }
</style>

<svelte:window bind:innerWidth={innerWidth} />

<CustomModal bind:show={showShareSellSheetModal} {sellSheet} closeOnBackgroundClick={true} overflow={'auto'} {responsiveLayout}>
  <section>
    <header class='fizz-space-between fizz-inset-square-16 fizz-stack-8 fizz-border-bottom'>
      <h4 class='fizz-heading-4'>Share "{sellSheet.name || 'Untitled Sheet'}"</h4>
      <div class='close-share-sellsheet-modal' on:click={closeModal}>
        <Icon type='X' extraClassNames='fizz-text-brand cursor-pointer' height='16' width='16'></Icon>
      </div>
    </header>
    <div class='share-method' class:fizz-stack-32={!responsiveLayout} class:fizz-inset-squish-16={!responsiveLayout} >
      <div class:fizz-inset-squish-16={responsiveLayout}>
        <p class="fizz-stack-16">
          <strong>Share</strong>&nbsp&nbsp<span class='fizz-text-subdued'>Recommended, accessible in Provi app</span>
        </p>
        {#each shareOptions as option}
          <label class='fizz-flex-row-8 fizz-stack-12' for={option.name}>
            <input
              type='radio'
              class='fizz-radio-button'
              name={option.name}
              id={option.name}
              value={option.value}
              bind:group={shareType}
              checked={shareType === option.value}
            />
            <span>{option.label}</span>
          </label>
        {/each}
      </div>
      {#if shareType === 'select'}
        <ShareSelectRetailers bind:sharingWithRetailers {searchRetailers}
          {retailersLoaded} {sellSheet} {responsiveLayout} />
      {/if}
    </div>
    <footer class='fizz-modal-footer fizz-inset-square-16 fizz-flex-row fizz-justify-end fizz-surface
    fizz-padded-border-top' class:sticky-footer={shareType === 'select'}>
      <button class='fizz-button' on:click={closeModal}>Cancel</button>
      <button class='fizz-button-secondary' id='modal-share-button'
        on:click={shareWith} disabled={disableButton || showLoading}>Share</button>
    </footer>
  </section>
</CustomModal>
